// File: src/pages/business/CreateJobPage.jsx
import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { createPortal } from 'react-dom'; // ✅ BƯỚC 1: IMPORT PORTAL
const JOB_LIMITS = {
    free: { limit: 1, name: 'STARTER' },
    pro: { limit: 10, name: 'PROFESSIONAL' },
    premium: { limit: 9999, name: 'ENTERPRISE' }
};

// ✅ CẬP NHẬT MODAL: DÙNG PORTAL ĐỂ THOÁT KHỎI LAYOUT CHA
const AIJobModal = ({ onClose, onGenerate, isLoading }) => {
    const [keywords, setKeywords] = useState('');

    const suggestions = [
        "ReactJS, Nodejs", "Lương tháng 13", "Review lương 2 lần/năm", 
        "Tiếng Anh giao tiếp", "Làm việc Hybrid", "Bảo hiểm Full lương"
    ];

    const addSuggestion = (text) => {
        setKeywords(prev => prev ? `${prev}, ${text}` : text);
    };

    // ✅ BƯỚC 2: WRAP BẰNG createPortal(JSX, document.body)
    return createPortal(
        <div style={{ 
            position: 'fixed', 
            top: 0, 
            left: 0,
            width: '100vw', 
            height: '100vh', 
            backgroundColor: 'rgba(0,0,0,0.75)', // Đen mờ đậm
             // Thêm chút blur nhẹ cho sang (tùy chọn)
            display: 'flex', 
            alignItems: 'center', 
            justifyContent: 'center', 
            zIndex: 999999 // Layer cao nhất
        }} onClick={onClose}> {/* Click ra ngoài để đóng */}
            
            {/* Modal Container - Chặn sự kiện click để không đóng khi click vào nội dung */}
            <div onClick={(e) => e.stopPropagation()} style={{ background: 'white', borderRadius: '16px', width: '90%', maxWidth: '800px', maxHeight:'90vh', display:'flex', flexDirection:'column', boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.5)', animation: 'popIn 0.2s ease-out' }}>
                
                {/* Header */}
                <div style={{ padding: '24px', borderBottom: '1px solid #E5E7EB', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <div>
                        <h3 style={{ fontSize: '20px', fontWeight: 'bold', color: '#111827', display:'flex', alignItems:'center', gap:'8px' }}>
                            <span className="material-symbols-outlined" style={{color:'#8B5CF6', fontSize:'28px'}}>auto_awesome</span> 
                            Viết JD tự động bằng AI
                        </h3>
                        <p style={{fontSize:'14px', color:'#6B7280', marginTop:'4px'}}>Nhập các yêu cầu chính, AI sẽ viết thành bản mô tả công việc chuyên nghiệp cho bạn.</p>
                    </div>
                    <button onClick={onClose} style={{padding:'8px', borderRadius:'50%', border:'none', background:'transparent', cursor:'pointer', color:'#9CA3AF'}}>
                        <span className="material-symbols-outlined" style={{fontSize:'28px'}}>close</span>
                    </button>
                </div>

                {/* Body */}
                <div style={{ padding: '24px', overflowY:'auto' }}>
                    <label style={{display:'block', fontSize:'14px', fontWeight:'600', color:'#374151', marginBottom:'8px'}}>
                        Từ khóa / Yêu cầu sơ bộ:
                    </label>
                    <textarea 
                        style={{
                            width: '100%', padding: '16px', borderRadius: '12px', border: '1px solid #D1D5DB', 
                            fontSize: '16px', lineHeight: '1.5', minHeight: '200px', outline: 'none',
                            fontFamily: 'inherit', resize: 'vertical'
                        }}
                        placeholder="Ví dụ: Cần tuyển Senior ReactJS, 3 năm kinh nghiệm. Yêu cầu biết Redux, NextJS. Có tiếng Anh là lợi thế. Đãi ngộ tốt, du lịch hàng năm..."
                        value={keywords}
                        onChange={(e) => setKeywords(e.target.value)}
                        autoFocus
                    ></textarea>

                    {/* Gợi ý nhanh */}
                    <div style={{marginTop:'16px'}}>
                        <p style={{fontSize:'12px', color:'#6B7280', marginBottom:'8px', fontWeight:'600', textTransform:'uppercase'}}>Gợi ý nhanh:</p>
                        <div style={{display:'flex', flexWrap:'wrap', gap:'8px'}}>
                            {suggestions.map((s, i) => (
                                <button key={i} onClick={() => addSuggestion(s)} style={{
                                    padding:'6px 12px', borderRadius:'20px', border:'1px solid #E5E7EB', 
                                    background:'white', color:'#4B5563', fontSize:'13px', cursor:'pointer',
                                    transition:'all 0.2s'
                                }}
                                onMouseEnter={(e) => {e.currentTarget.style.borderColor='#8B5CF6'; e.currentTarget.style.color='#7C3AED'}}
                                onMouseLeave={(e) => {e.currentTarget.style.borderColor='#E5E7EB'; e.currentTarget.style.color='#4B5563'}}
                                >
                                    + {s}
                                </button>
                            ))}
                        </div>
                    </div>
                </div>

                {/* Footer */}
                <div style={{ padding: '24px', borderTop: '1px solid #E5E7EB', background: '#F9FAFB', borderBottomLeftRadius:'16px', borderBottomRightRadius:'16px', display:'flex', justifyContent:'flex-end', gap:'12px' }}>
                    <button 
                        onClick={onClose}
                        style={{ padding: '12px 24px', borderRadius: '8px', border: '1px solid #D1D5DB', background: 'white', color: '#374151', fontWeight: '600', cursor: 'pointer' }}
                    >
                        Hủy bỏ
                    </button>
                    <button 
                        onClick={() => onGenerate(keywords)}
                        disabled={isLoading || !keywords}
                        style={{
                            padding: '12px 32px', borderRadius: '8px', border: 'none', 
                            background: isLoading ? '#E5E7EB' : 'linear-gradient(to right, #7C3AED, #2563EB)', 
                            color: isLoading ? '#9CA3AF' : 'white', 
                            fontWeight: '600', cursor: isLoading ? 'not-allowed' : 'pointer',
                            display: 'flex', alignItems: 'center', gap: '8px', boxShadow: '0 4px 6px -1px rgba(124, 58, 237, 0.3)'
                        }}
                    >
                        {isLoading ? (
                            <> <span className="material-symbols-outlined spin">sync</span> Đang viết nội dung... </>
                        ) : (
                            <> <span className="material-symbols-outlined">auto_awesome</span> Tạo nội dung ngay </>
                        )}
                    </button>
                </div>
            </div>
            <style>{`
                @keyframes popIn {
                    from { opacity: 0; transform: scale(0.95); }
                    to { opacity: 1; transform: scale(1); }
                }
            `}</style>
        </div>,
        document.body // Target DOM Node
    );
};

export default function CreateJobPage() {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [myTests, setMyTests] = useState([]);
    const { id } = useParams();
    const isEditMode = !!id;
    const [showConfirmModal, setShowConfirmModal] = useState(false);
    const [showAIModal, setShowAIModal] = useState(false);
    const [isGenerating, setIsGenerating] = useState(false);
    const [userPlan, setUserPlan] = useState('free');
    const [jobsThisMonth, setJobsThisMonth] = useState(0);
    const [isLimitReached, setIsLimitReached] = useState(false);
    const [upgradeModal, setUpgradeModal] = useState({ show: false, message: '' });

    // Form dữ liệu Job
    const [jobData, setJobData] = useState({
        title: '',
        salary: '',
        location: '',
        type: 'Full-time',
        description: '',
        requirements: '',
        benefits: '',
        startDate: '',
        endDate: '',
        requiredAssessment: ''
    });

    const API_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:3001';

    // 1. Lấy danh sách bài test
    useEffect(() => {
        const initData = async () => {
            const token = localStorage.getItem('skillmatch_token');
            if (!token) return;

            try {
                // 1. Lấy thông tin Gói cước
                const meRes = await fetch(`${API_URL}/api/auth/me`, { headers: { 'x-auth-token': token } });
                const meData = await meRes.json();
                const plan = meData.subscription?.plan || 'free';
                setUserPlan(plan);

                // 2. Lấy danh sách Job để đếm (Trong tháng này)
                const jobRes = await fetch(`${API_URL}/api/jobs/my-jobs`, { headers: { 'x-auth-token': token } });
                if (jobRes.ok) {
                    const allJobs = await jobRes.json();
                    
                    // Lọc Job tạo trong tháng hiện tại
                    const now = new Date();
                    const startOfMonth = new Date(now.getFullYear(), now.getMonth(), 1);
                    const count = allJobs.filter(j => new Date(j.createdAt) >= startOfMonth).length;
                    
                    setJobsThisMonth(count);

                    // Check Limit (Chỉ chặn khi TẠO MỚI)
                    const limit = JOB_LIMITS[plan]?.limit || 1;
                    if (!isEditMode && count >= limit) {
                        setIsLimitReached(true);
                    }
                }

                // 3. Load danh sách bài test (để chọn trong form)
                const testRes = await fetch(`${API_URL}/api/tests/my-tests`, { headers: { 'x-auth-token': token } });
                if (testRes.ok) setMyTests(await testRes.json());

                // 4. Nếu Edit -> Load chi tiết Job
                if (isEditMode) {
                    const detailRes = await fetch(`${API_URL}/api/jobs/${id}`, { headers: { 'x-auth-token': token } });
                    if (detailRes.ok) {
                        const data = await detailRes.json();
                        setJobData({
                            ...data,
                            description: Array.isArray(data.description) ? data.description.join('\n') : data.description,
                            requirements: Array.isArray(data.requirements) ? data.requirements.join('\n') : data.requirements,
                            benefits: Array.isArray(data.benefits) ? data.benefits.join('\n') : data.benefits,
                            requiredAssessment: data.requiredAssessment ? data.requiredAssessment._id : '',
                            startDate: data.startDate ? data.startDate.split('T')[0] : '',
                            endDate: data.endDate ? data.endDate.split('T')[0] : ''
                        });
                    }
                }
            } catch (e) { console.error("Init Error:", e); }
        };
        initData();
    }, [API_URL, id, isEditMode]);

    const handleChange = (e) => {
        setJobData({ ...jobData, [e.target.name]: e.target.value });
    };

    const formatDateInput = (isoString) => {
        if (!isoString) return '';
        return new Date(isoString).toISOString().split('T')[0];
    };

    const handleCloseJobClick = () => {
        setShowConfirmModal(true);
    };
    const confirmCloseJob = () => {
        setJobData(prev => ({ ...prev, status: 'Đã đóng' }));
        setShowConfirmModal(false);
    };

    const handleReopenJob = () => {
        setJobData(prev => ({ ...prev, status: 'Đang tuyển' }));
    };
    const validateForm = () => {
        // 1. Validate Ngày tháng
        if (jobData.startDate && jobData.endDate) {
            const start = new Date(jobData.startDate);
            const end = new Date(jobData.endDate);
            if (end <= start) {
                alert("Ngày kết thúc phải sau ngày bắt đầu!");
                return false;
            }
        }

        // 2. Validate Lương (Không rỗng & > 3 ký tự)
        if (!jobData.salary || jobData.salary.trim().length < 3) {
            alert("Vui lòng nhập mức lương hợp lệ (VD: 10 - 20 triệu)");
            return false;
        }

        // 3. Validate Nội dung chi tiết (Độ dài tối thiểu 50 ký tự)
        if (jobData.description.trim().length < 50) {
            alert("Mô tả công việc quá ngắn! Vui lòng nhập chi tiết hơn (tối thiểu 50 ký tự).");
            return false;
        }
        if (jobData.requirements.trim().length < 20) { // Yêu cầu thấp hơn chút
            alert("Yêu cầu ứng viên quá ngắn! Vui lòng nhập chi tiết hơn (tối thiểu 20 ký tự).");
            return false;
        }
        if (jobData.benefits.trim().length < 20) {
            alert("Quyền lợi quá ngắn! Vui lòng nhập chi tiết hơn (tối thiểu 20 ký tự).");
            return false;
        }

        return true;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validateForm()) return;
        if (isLimitReached && !isEditMode) {
            setUpgradeModal({ show: true, message: `Bạn đã hết lượt đăng tin trong tháng (${JOB_LIMITS[userPlan].limit} tin). Vui lòng nâng cấp!` });
            return;
        }
        setLoading(true);
        const token = localStorage.getItem('skillmatch_token');

        try {
            const payload = {
                ...jobData,
                description: jobData.description.split('\n').filter(i => i.trim()),
                requirements: jobData.requirements.split('\n').filter(i => i.trim()),
                benefits: jobData.benefits.split('\n').filter(i => i.trim()),
                requiredAssessment: jobData.requiredAssessment || null,
                startDate: jobData.startDate || new Date(),
                endDate: jobData.endDate || null
            };

            const url = isEditMode ? `${API_URL}/api/jobs/${id}` : `${API_URL}/api/jobs`;
            const method = isEditMode ? 'PUT' : 'POST';

            const res = await fetch(url, {
                method: method,
                headers: { 'Content-Type': 'application/json', 'x-auth-token': token },
                body: JSON.stringify(payload)
            });

            const data = await res.json();
            if (res.status === 403 || data.requireUpgrade) {
                setUpgradeModal({ show: true, message: data.message });
                return;
            }
            if (!res.ok) {
                throw new Error(data.message || 'Lỗi khi tạo tin tuyển dụng');
            }
            navigate('/business/jobs', {
                state: {
                    successMessage: isEditMode
                        ? "Cập nhật tin tuyển dụng thành công!"
                        : "Đăng tin tuyển dụng mới thành công!"
                }
            });

        } catch (error) {
           alert("Đăng tin thất bại: " + error.message);
        } finally {
            setLoading(false);
        }
    };

    const handleAIGenerate = async (keywords) => {
        if (!jobData.title) {
            alert("Vui lòng nhập Tiêu đề công việc ở màn hình chính trước!");
            return;
        }
        setIsGenerating(true);
        try {
            const token = localStorage.getItem('skillmatch_token');
            const res = await fetch(`${API_URL}/api/jobs/generate-ai`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'x-auth-token': token },
                body: JSON.stringify({ title: jobData.title, keywords })
            });
            const data = await res.json();
            if (!res.ok) throw new Error(data.message);

            const formatBullet = (content) => {
                if (Array.isArray(content)) {
                    return content.map(line => `• ${line}`).join('\n\n'); 
                }
                return content;
            };

            setJobData(prev => ({
                ...prev,
                description: formatBullet(data.description),
                requirements: formatBullet(data.requirements),
                benefits: formatBullet(data.benefits)
            }));
            setShowAIModal(false);
        } catch (e) {
            alert("Lỗi AI: " + e.message);
        } finally {
            setIsGenerating(false);
        }
    };

    return (
        <div className="create-job-page">
            
            {/* MODAL AI (Sử dụng Portal nên có thể đặt ở bất cứ đâu trong return) */}
            {showAIModal && <AIJobModal onClose={() => setShowAIModal(false)} onGenerate={handleAIGenerate} isLoading={isGenerating} />}

            <form onSubmit={handleSubmit} className="job-form-container">
                {isLimitReached && !isEditMode && (
                    <div style={{ backgroundColor: '#FEF2F2', border: '1px solid #FECACA', borderRadius: '12px', padding: '16px', marginBottom: '24px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '12px', color: '#991B1B' }}>
                            <span className="material-symbols-outlined">warning</span>
                            <span>
                                <strong>Đã đạt giới hạn tháng này!</strong> Gói {JOB_LIMITS[userPlan].name} cho phép đăng {JOB_LIMITS[userPlan].limit} tin/tháng. (Đã dùng: {jobsThisMonth})
                            </span>
                        </div>
                        <button type="button" onClick={() => navigate('/business/upgrade-account')} style={{ background: '#DC2626', color: 'white', border: 'none', padding: '8px 16px', borderRadius: '6px', fontWeight: 'bold', cursor: 'pointer' }}>
                            Nâng cấp ngay
                        </button>
                    </div>
               )}
               
               <div className="form-grid">
                    {/* CỘT TRÁI */}
                    <div className="left-col">
                         <div className="card">
                            <h3 className="card-title"><span className="material-symbols-outlined icon">article</span> Thông tin cơ bản</h3>
                            <div className="form-group">
                                <label>Tiêu đề công việc <span className="req">*</span></label>
                                <div className="input-wrapper">
                                    <input required name="title" value={jobData.title} onChange={handleChange} placeholder="VD: Senior ReactJS Developer" />
                                </div>
                            </div>

                            <div className="row-2">
                                <div className="form-group">
                                    <label>Mức lương</label>
                                    <div className="input-wrapper">
                                        <span className="material-symbols-outlined input-icon">attach_money</span>
                                        <input name="salary" value={jobData.salary} onChange={handleChange} placeholder="VD: 1000 - 2000 USD" />
                                    </div>
                                </div>
                                <div className="form-group">
                                    <label>Loại hình</label>
                                    <div className="input-wrapper">
                                        <span className="material-symbols-outlined input-icon">work</span>
                                        <select name="type" value={jobData.type} onChange={handleChange}>
                                            <option value="Full-time">Full-time</option>
                                            <option value="Part-time">Part-time</option>
                                            <option value="Remote">Remote</option>
                                            <option value="Hybrid">Hybrid</option>
                                            <option value="Internship">Internship</option>
                                        </select>
                                    </div>
                                </div>
                            </div>

                            <div className="form-group">
                                <label>Địa điểm làm việc</label>
                                <div className="input-wrapper">
                                    <span className="material-symbols-outlined input-icon">location_on</span>
                                    <input name="location" value={jobData.location} onChange={handleChange} placeholder="VD: Tầng 5, Tòa nhà Tech, Hà Nội" />
                                </div>
                            </div>

                            <div className="row-2" style={{ marginTop: '20px', paddingTop: '20px', borderTop: '1px solid #F3F4F6' }}>
                                <div className="form-group">
                                    <label>Ngày bắt đầu</label>
                                    <div className="input-wrapper">
                                        <span className="material-symbols-outlined input-icon">calendar_today</span>
                                        <input type="date" name="startDate" value={jobData.startDate} onChange={handleChange} onClick={(e) => e.target.showPicker && e.target.showPicker()} style={{ cursor: 'pointer' }} />
                                    </div>
                                </div>
                                <div className="form-group" >
                                    <label>Hạn nộp hồ sơ</label>
                                    <div className="input-wrapper">
                                        <span className="material-symbols-outlined input-icon">event_available</span>
                                        <input type="date" name="endDate" value={jobData.endDate} onChange={handleChange} onClick={(e) => e.target.showPicker && e.target.showPicker()} style={{ borderColor: jobData.endDate ? '#2563EB' : '', cursor: 'pointer' }} />
                                    </div>
                                </div>
                            </div>
                         </div>

                         {/* ASSESSMENT CARD */}
                         <div className="card assessment-card">
                            <div className="assessment-header">
                                <div className="icon-box"><span className="material-symbols-outlined">assignment_add</span></div>
                                <div>
                                    <h3 className="card-title" style={{ marginBottom: 4, color: '#1E40AF' }}>Yêu cầu bài kiểm tra năng lực</h3>
                                    <p className="card-desc">Ứng viên bắt buộc phải hoàn thành bài test này để được nộp hồ sơ.</p>
                                </div>
                            </div>
                            <div className="assessment-select-wrapper">
                                <select name="requiredAssessment" value={jobData.requiredAssessment} onChange={handleChange} className={jobData.requiredAssessment ? 'has-value' : ''}>
                                    <option value="">-- Không yêu cầu (Chỉ nộp CV) --</option>
                                    {myTests.map(test => (
                                        <option key={test._id} value={test._id}>{test.assessmentName} {test.isPublic ? '(Công khai)' : '🔒 (Tuyển dụng)'}</option>
                                    ))}
                                </select>
                                <span className="material-symbols-outlined select-arrow">expand_more</span>
                            </div>
                            {jobData.requiredAssessment && (
                                <div className="assessment-success"><span className="material-symbols-outlined">check_circle</span><span>Đã liên kết bài test thành công.</span></div>
                            )}
                        </div>
                    </div>

                    {/* CỘT PHẢI: CHI TIẾT */}
                    <div className="right-col">
                        <div className="card">
                            <div style={{display:'flex', justifyContent:'space-between', alignItems:'center', borderBottom:'1px solid #F3F4F6', paddingBottom:'12px', marginBottom:'20px'}}>
                                <h3 className="card-title" style={{margin:0, border:0, padding:0}}><span className="material-symbols-outlined icon">description</span> Chi tiết công việc</h3>
                                
                                {/* NÚT KÍCH HOẠT AI */}
                                <button type="button" onClick={() => setShowAIModal(true)} className="px-3 py-1.5 bg-purple-50 text-purple-700 rounded-lg text-xs font-bold flex items-center gap-1 hover:bg-purple-100 transition-colors border border-purple-200">
                                    <span className="material-symbols-outlined text-[16px]">auto_awesome</span> Viết bằng AI
                                </button>
                            </div>

                            <div className="form-group">
                                <label>Mô tả công việc (JD)</label>
                                <textarea name="description" rows="8" value={jobData.description} onChange={handleChange} placeholder="- Tham gia phát triển dự án..." />
                            </div>

                            <div className="form-group">
                                <label>Yêu cầu chuyên môn</label>
                                <textarea name="requirements" rows="8" value={jobData.requirements} onChange={handleChange} placeholder="- Có ít nhất 2 năm kinh nghiệm..." />
                            </div>

                            <div className="form-group">
                                <label>Quyền lợi & Đãi ngộ</label>
                                <textarea name="benefits" rows="8" value={jobData.benefits} onChange={handleChange} placeholder="- Lương tháng 13..." />
                            </div>
                        </div>
                    </div>
                </div>

               {/* FOOTER ACTIONS */}
               <div className="form-footer">
                    <button type="button" className="btn-cancel" onClick={() => navigate('/business/jobs')}>Hủy bỏ</button>
                    {isEditMode && (
                        jobData.status === 'Đang tuyển' ? (
                            <button onClick={handleCloseJobClick} type="button" className="px-4 py-2 bg-red-100 text-red-700 rounded-lg font-medium text-sm hover:bg-red-200 transition-colors flex items-center gap-2">
                                <span className="material-symbols-outlined text-lg">block</span> Đóng tuyển dụng
                            </button>
                        ) : (
                            <button onClick={handleReopenJob} type="button" className="px-4 py-2 bg-green-100 text-green-700 rounded-lg font-medium text-sm hover:bg-green-200 transition-colors flex items-center gap-2">
                                <span className="material-symbols-outlined text-lg">refresh</span> Mở lại tuyển dụng
                            </button>
                        )
                    )}
                    <button 
                        type="submit" 
                        disabled={loading || (isLimitReached && !isEditMode)} 
                        className="btn-submit"
                        style={{ 
                            opacity: (isLimitReached && !isEditMode) ? 0.5 : 1, 
                            cursor: (isLimitReached && !isEditMode) ? 'not-allowed' : 'pointer' 
                        }}
                    >
                        {loading ? 'Đang lưu...' : (isLimitReached && !isEditMode ? 'Đạt giới hạn' : (isEditMode ? 'Lưu thay đổi' : 'Đăng tin'))}
                    </button>
                </div>
            </form>

            {/* MODAL CONFIRM CLOSE (Cũng dùng Portal cho chắc chắn) */}
            {showConfirmModal && createPortal(
                <div style={{ position: 'fixed', inset: 0, backgroundColor: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 50 }}>
                    <div style={{ backgroundColor: 'white', borderRadius: '12px', padding: '24px', width: '400px', boxShadow: '0 20px 25px -5px rgba(0,0,0,0.1)' }}>
                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center' }}>
                            <div style={{ width: '48px', height: '48px', backgroundColor: '#FEE2E2', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '16px', color: '#DC2626' }}>
                                <span className="material-symbols-outlined" style={{ fontSize: '28px' }}>warning</span>
                            </div>
                            <h3 style={{ fontSize: '18px', fontWeight: 'bold', color: '#111827', marginBottom: '8px' }}>Đóng tin tuyển dụng?</h3>
                            <p style={{ fontSize: '14px', color: '#6B7280', marginBottom: '24px', lineHeight: '1.5' }}>Bạn có chắc chắn muốn đóng vị trí này? Ứng viên sẽ không thể nộp hồ sơ nữa. <br/>(Bạn có thể mở lại sau).</p>
                            <div style={{ display: 'flex', gap: '12px', width: '100%' }}>
                                <button onClick={() => setShowConfirmModal(false)} style={{ flex: 1, padding: '10px', borderRadius: '8px', border: '1px solid #D1D5DB', backgroundColor: 'white', color: '#374151', fontWeight: '600', cursor: 'pointer' }}>Hủy bỏ</button>
                                <button onClick={confirmCloseJob} style={{ flex: 1, padding: '10px', borderRadius: '8px', border: 'none', backgroundColor: '#DC2626', color: 'white', fontWeight: '600', cursor: 'pointer' }}>Đóng ngay</button>
                            </div>
                        </div>
                    </div>
                </div>, document.body
            )}

            {/* CSS STYLES */}
            <style>{`
            .create-job-page {
                background-color: #F3F4F6;
                min-height: 100vh;
                padding: 40px 24px;
                font-family: 'Inter', sans-serif;
                color: #111827;
            }
            .job-form-container {
                max-width: 1000px;
                margin: 0 auto;
            }
            .form-grid {
                display: grid;
                grid-template-columns: 1.2fr 1.5fr; 
                gap: 24px;
            }
            @media (max-width: 900px) { .form-grid { grid-template-columns: 1fr; } }

            .card {
                background: white;
                border-radius: 12px;
                padding: 24px;
                box-shadow: 0 1px 3px rgba(0,0,0,0.05);
                border: 1px solid #E5E7EB;
                margin-bottom: 24px;
            }
            .card-title {
                font-size: 16px; font-weight: 600; color: #111827;
                margin: 0 0 20px;
                display: flex; align-items: center; gap: 8px;
                padding-bottom: 12px;
                border-bottom: 1px solid #F3F4F6;
            }
            .card-title .icon { color: #2563EB; font-size: 20px; }
            
            .form-group { margin-bottom: 20px; }
            .form-group label {
                display: block; font-size: 13px; font-weight: 500; color: #374151; margin-bottom: 6px;
            }
            .form-group label .req { color: #EF4444; }
            .form-group .helper { font-size: 12px; color: #9CA3AF; margin-top: -4px; margin-bottom: 8px; font-style: italic; }

            .input-wrapper { position: relative; }
            .input-wrapper .input-icon {
                position: absolute; left: 12px; top: 50%; transform: translateY(-50%);
                font-size: 20px; color: #9CA3AF; pointer-events: none;
            }
            
            input, select, textarea {
                width: 100%;
                padding: 10px 12px;
                border: 1px solid #D1D5DB;
                border-radius: 8px;
                font-size: 14px;
                color: #111827;
                outline: none;
                transition: all 0.2s;
                background: #FFFFFF;
            }
            .input-wrapper input, .input-wrapper select { padding-left: 40px; }
            
            input:focus, select:focus, textarea:focus {
                border-color: #2563EB;
                box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1);
            }
            
            .row-2 { display: grid; grid-template-columns: 1fr 1fr; gap: 16px; }

            .assessment-card {
                background: linear-gradient(to bottom right, #EFF6FF, #FFFFFF);
                border: 1px solid #BFDBFE;
            }
            .assessment-header { display: flex; gap: 16px; margin-bottom: 16px; }
            .assessment-header .icon-box {
                width: 48px; height: 48px;
                background: #DBEAFE; color: #1E40AF;
                border-radius: 12px;
                display: flex; align-items: center; justify-content: center;
            }
            .card-desc { font-size: 13px; color: #4B5563; margin: 0; line-height: 1.4; }

            .assessment-select-wrapper { position: relative; }
            .assessment-select-wrapper select {
                background: white; border: 1px solid #93C5FD;
                font-weight: 500; cursor: pointer;
                appearance: none;
            }
            .assessment-select-wrapper select.has-value {
                border-color: #2563EB; color: #1E40AF; background: #F0F9FF;
            }
            .select-arrow {
                position: absolute; right: 12px; top: 50%; transform: translateY(-50%);
                pointer-events: none; color: #6B7280;
            }
            .assessment-success {
                margin-top: 12px;
                display: flex; align-items: center; gap: 6px;
                font-size: 13px; font-weight: 500; color: #059669;
                background: #ECFDF5; padding: 8px 12px; border-radius: 6px;
            }
            .assessment-success span.material-symbols-outlined { font-size: 18px; }

            .form-footer {
                display: flex; justify-content: flex-end; gap: 12px;
                margin-top: 24px; padding-top: 24px;
                border-top: 1px solid #E5E7EB;
            }
            .btn-cancel {
                padding: 10px 20px; border-radius: 8px; border: 1px solid #D1D5DB;
                background: white; color: #374151; font-weight: 600; cursor: pointer;
                transition: all 0.2s;
            }
            .btn-cancel:hover { background: #F9FAFB; }
            .btn-submit {
                padding: 10px 24px; border-radius: 8px; border: none;
                background: #2563EB; color: white; font-weight: 600; cursor: pointer;
                display: flex; align-items: center; gap: 8px;
                box-shadow: 0 4px 6px -1px rgba(37, 99, 235, 0.2);
                transition: all 0.2s;
            }
            .btn-submit:hover { background: #1D4ED8; transform: translateY(-1px); }
            .btn-submit:disabled { opacity: 0.7; cursor: not-allowed; transform: none; }
            .spin { animation: spin 1s linear infinite; }
            @keyframes spin { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }
            `}</style>
        </div>
    );
}